var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcons01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbf9f8;\n      }\n\n      .cls-2 {\n        fill: #152839;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 200,
    cy: 200,
    r: 196.43
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.68,105.9c-13.68-.69-24.92,10.54-24.22,24.22.59,11.71,10.11,21.23,21.82,21.83,13.68.69,24.92-10.55,24.23-24.23-.59-11.71-10.11-21.23-21.83-21.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.67,
    y: 167.43,
    width: 41.63,
    height: 126.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.24,164.45c-16.02,0-27.27,7.64-35.14,17.4v-14.42h-41.63v126.69h41.63v-74.24c1.13-15.95,12.52-20.11,20.59-20.11,8.51,0,19.25,4.14,19.25,27.42v66.93h41.63v-89.24s-1.87-40.44-46.34-40.44Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcons01);
export default __webpack_public_path__ + "static/media/social_icons-01.a12d245756a5ffb867d722d96112637b.svg";
export { ForwardRef as ReactComponent };